import { useState } from "react";
import "./index.scss";
import { ScrollSection } from "../scroll-section";

export const Tabs = ({ tabs, id, setId }) => {

  const handleTabClick = (tabId) => {
    setId(tabId);
  };

  return (
    <div className="tabs-container">
      <div className="tabs-header">
        <ScrollSection>
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`tab ${id === tab.id ? "active" : ""} 
            ${tab.enable === false ? "disable" : ""}`}
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.info && <span className="info">{tab.info}</span>}
            <span className="label">{tab.label}</span>
            {tab.subtitle && <span className="subtitle">{tab.subtitle}</span>}
          </div>
        ))}
        </ScrollSection>
      </div>
      <div className="tabs-content">
        <div>
          {tabs.find(x=> x.id == id).content}
        </div>
      </div>
    </div>
  );
};
